import { render } from "./HomePanel.vue?vue&type=template&id=15e3c098&scoped=true"
import script from "./HomePanel.vue?vue&type=script&lang=js"
export * from "./HomePanel.vue?vue&type=script&lang=js"

import "./HomePanel.vue?vue&type=style&index=0&id=15e3c098&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e3c098"]])

export default __exports__